import React from "react";
import AgentsAdminLayout from "../../template/admin.layout";
import FixedScrollSectionTemplate from "../../components/fixed-scroll-section";
import PanelLoading from "../../../../../components/panel/panel.loading";
import AgentCreateForm from "./agent-create-form/agent-create-form";

const AgentCreatePage = () => {
  return (
    <AgentsAdminLayout>
      <div className="mt-32 h-full w-full pb-32">
        <FixedScrollSectionTemplate classname="h-full">
          <div className="my-6 flex flex-grow flex-col items-center justify-center">
            <div className="w-full md:w-3/4">
              <PanelLoading title={`Crear nuevo agente`} isLoading={false}>
                <AgentCreateForm />
              </PanelLoading>
            </div>
          </div>
        </FixedScrollSectionTemplate>
      </div>
    </AgentsAdminLayout>
  );
};

export default AgentCreatePage;
